import React from 'react'

const Post = ({post, index, handleDeletePost})=>{
    if (post && Object.keys(post).length > 0) {
        return (
            <div className='post'>
                <h2>{post.title}</h2>
                <h3>{post.subtitle}</h3>
                <p>{post.content}</p>
                <button className="delete-btn" onClick={() => handleDeletePost(index)}>Delete</button>
            </div>
        );
    } else {
        // Render "Post not available" message if post is not available
        return (
            <div className='post'>
                <p>Post not available</p>
            </div>
        );
    }
};

export default Post;